import log from 'salvo-lite/log'
import axios from 'axios'

class ForceVariants {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._input = elem.querySelector('[name="id"]')
        this._selects = elem.querySelectorAll('select')
        this._variants = JSON.parse(elem.getAttribute('data-force-variants'))
        this._data = Object.assign({
            product: elem.closest('[data-product]'),
            selectors: {
                images: 'product__images'
            },
            productHandle: elem.getAttribute('data-handle'),
            ajaxElementSelectors: [
                '.product__ignore',
                '.product__price',
                '.product__images',
                '.product__tags',
                '.product__actions',
                '.nutritional-info',
                '.product-add-bar .container',
                '.product__description',
                '.product-accordion',
                '.product__title'
            ],
            ajaxElementSelectorsSizeOnly: [
                '.product__ignore',
                '.product__price',
                '.product__actions',
                '.nutritional-info',
                '.product-add-bar .container',
                '.product__description'
            ]
        }, JSON.parse(elem.getAttribute('data-variants') || '{}'))
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._selects.forEach(select => {
            select.addEventListener('change', e => {
                this._options(select)
            })
        })
    }
    _options (select) {
        let options = []
        switch (select.name) {
        case 'option1':
            if (this._selects[2]) {
                this._selects[2].setAttribute('disabled', '')
            }
            let loop = 0
            let img = []
            this._variants.forEach(variant => {
                if (variant.option1 === select.value) {
                    if (!options.includes(variant.option2)) {
                        loop += 1
                        options.push(variant.option2)
                        if (loop === 1) {
                            img.push(variant.featured_image.src)
                        }
                    }
                }
            })
            this._createOptions(this._selects[1], options, img)
            if (this._selects[2]) {
                this._variants.forEach(variant => {
                    if (variant.option2 === select.value && variant.option1 === this._selects[0].value) {
                        if (!options.includes(variant.option3)) {
                            options.push(variant.option3)
                        }
                    }
                })
                this._createOptions(this._selects[2], options)
            }
            break
        case 'option2':
            this._variants.forEach(variant => {
                if (variant.option2 === select.value && variant.option1 === this._selects[0].value) {
                    if (!options.includes(variant.option3)) {
                        options.push(variant.option3)
                    }
                }
            })
            this._createOptions(this._selects[2], options)
            break
        case 'option3':
            this._checkVariant()
            break
        }
    }
    _createOptions (select, options, img) {
        if (select) {
            select.dispatchEvent(new Event('destroy'))
            let html = '<option placeholder selected value="">' + select.getAttribute('data-name') + '</option>'
            options.forEach(option => {
                html += '<option value="' + option + '">' + option + '</option>'
            })
            select.innerHTML = html
            select.removeAttribute('disabled')
            select.dispatchEvent(new Event('reInit'))
        }
        this._checkVariant(img)
    }
    _checkVariant (img) {
        let variantTitle = ''
        this._selects.forEach(select => {
            variantTitle += select.value + ' / '
        })
        variantTitle = variantTitle.slice(0, -3)
        let variant = ''
        let variantObj = ''
        this._variants.forEach(variantOpt => {
            if (variantOpt.title === variantTitle) {
                variant = variantOpt.id
                variantObj = variantOpt
            }
        })
        if (variant) {
            this._updateUrl(variant)
            this._updateInput(variantObj)
        } else {
            let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname
            window.history.replaceState({ path: newurl }, '', newurl)
            this._updateInput(' ')
        }
        this._updateContent(variant, img)
    }
    _updateUrl (id) {
        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + id
        window.history.replaceState({ path: newurl }, '', newurl)
    }
    _updateInput (variant) {
        this._input.value = variant.id
    }
    _updateImg (img) {
        const image = document.querySelector('.product__images-image img')
        image.src = img
    }
    _updateContent (newVariant, img) {
        const newVariantID = newVariant
        const {productHandle} = this._data
        const ajaxURL = `/products/${productHandle}?variant=${newVariantID}`
        const existingAjaxElements = this._getAjaxElements()

        this._blurImages()

        axios.get(ajaxURL).then((response) => {
            const productPageContent = document.createElement('div')
            productPageContent.innerHTML = response.data

            const newAjaxElements = this._getAjaxElements(productPageContent.querySelector('[data-product]'))

            existingAjaxElements.forEach((elementList, elementListIndex) => elementList.forEach((element, elementIndex) => {
                this._replaceElement(element, newAjaxElements[elementListIndex][elementIndex])
            }))
        }).then(() => {
            if (img) {
                this._updateImg(img)
            }
            setTimeout(() => this._blurImages(false), 100)
        }).catch(error => console.error(error))
    }
    _blurImages (blur = true) {
        if (!this._isSize) {
            blur ? this._data.product.classList.add('blur-images') : this._data.product.classList.remove('blur-images')
        }
    }
    _getAjaxElements (productElement = this._data.product) {
        if (this._isSize) {
            return this._data.ajaxElementSelectorsSizeOnly.map(selector => productElement.querySelectorAll(selector))
        } else {
            return this._data.ajaxElementSelectors.map(selector => productElement.querySelectorAll(selector))
        }
    }
    _replaceElement (oldElement, newElement) {
        if (!oldElement.parentNode || !newElement) return

        this._removePreloader(oldElement, newElement)
        oldElement.parentNode.replaceChild(newElement, oldElement)
        this._wrapAndReRegisterComponent(newElement)
    }
    _removePreloader (oldElement, newElement) {
        if (oldElement.classList.contains(this._data.selectors.images)) {
            newElement.querySelectorAll('img').forEach(img => {
                if (img.hasAttribute('data-preload')) {
                    img.src = img.getAttribute('data-preload')
                    img.removeAttribute('data-preload')
                }
            })
        }
    }
    _wrapAndReRegisterComponent (newElement) {
        const temporaryWrapper = document.createElement('div')
        newElement.parentNode.insertBefore(temporaryWrapper, newElement)
        temporaryWrapper.appendChild(newElement)
        this._theme.registerComponents(temporaryWrapper)
        temporaryWrapper.parentNode.insertBefore(newElement, temporaryWrapper)
        temporaryWrapper.parentNode.removeChild(temporaryWrapper)
    }
}

export default ForceVariants



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ForceVariants.js